var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colors-container"},_vm._l((_vm.colorList),function(color,index){return _c('div',{key:index,staticClass:"color-block",class:{'selected-color':_vm.selectedIndex === index},style:({'backgroundColor':color.hex}),on:{"click":function($event){return _vm.selectedColor(index)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }